import './styles/fonts.css';
import './styles/tailwind-output.css';
require('./js/stickybits');
